import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { User } from "@/api/types"
import { logoutAction } from "@/store/session/logoutAction"
import type { RootState } from "@/store/store"

interface SuggestedState {
  users: User[]
}

const initialState: SuggestedState = {
  users: [],
}

const suggestedSlice = createSlice({
  name: "suggested",
  initialState,
  reducers: {
    setSuggested: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload
    },
    removeSuggestedUser: (state, action: PayloadAction<string>) => {
      state.users = state.users.filter((user) => user.id !== action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => initialState)
  },
})

export const { setSuggested, removeSuggestedUser } = suggestedSlice.actions

export const selectSuggestedUsers = (state: RootState) => state.suggested.users

export default suggestedSlice.reducer
